





























import { Component } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import OpportunitySources from '@/components/OpportunitySources/OpportunitySources.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';

@Component({
	name: 'AgencyOpportunitySourceSettings',
  	components: { OpportunitySources, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getOpportunitySources();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingOpportunitySources;
  	}
}
